import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ 
  selectedCount, 
  onApprove, 
  onReject, 
  onExport, 
  onDelete,
  onCategoryUpdate,
  onClearSelection 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-100 w-[calc(100%-2rem)] max-w-4xl">
      <div className="bg-card rounded-lg shadow-2xl border border-border p-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="font-body font-medium text-sm text-foreground">
                {selectedCount} {selectedCount === 1 ? 'expense' : 'expenses'} selected
              </p>
              <button
                onClick={onClearSelection}
                className="caption text-primary hover:text-primary/80 transition-smooth"
              >
                Clear selection
              </button>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-2 w-full sm:w-auto">
            <Button
              variant="success"
              size="sm"
              onClick={onApprove}
              iconName="CheckCircle"
              iconPosition="left"
            >
              Approve
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={onReject}
              iconName="XCircle"
              iconPosition="left"
            >
              Reject
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={onCategoryUpdate}
              iconName="Tag"
              iconPosition="left"
            >
              Update Category
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={onExport}
              iconName="Download"
              iconPosition="left"
            >
              Export
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={onDelete}
              iconName="Trash2"
              iconPosition="left"
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;